import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Resource } from '../models/resource.model';

export interface PaginatedResources {
  data: Resource[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasMore: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  public resourcesChanged = new Subject<void>();

  constructor(private http: HttpClient) {}

  // Used by the organization form (returns just the array of matches).
  getResourcesByType(searchTerm: string, type: string): Observable<Resource[]> {
    return this.http
      .get<PaginatedResources>(
        `/resources/getResourcesByType/${type}?searchTerm=${searchTerm}`
      )
      .pipe(map((res) => res.data));
  }

  // Used by the resources management screen (full paginated response).
  listResources(
    type: string,
    page: number,
    limit: number,
    searchTerm: string
  ): Observable<PaginatedResources> {
    let url = `/resources/getResourcesByType/${type}?page=${page}&limit=${limit}`;
    if (searchTerm) {
      url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }
    return this.http.get<PaginatedResources>(url);
  }

  createResource(payload: Partial<Resource>) {
    return this.http.post('/resources', payload).pipe(
      tap(() => {
        this.resourcesChanged.next();
      })
    );
  }

  updateResource(id: string, payload: Partial<Resource>) {
    return this.http.put(`/resources/${id}`, payload).pipe(
      tap(() => {
        this.resourcesChanged.next();
      })
    );
  }

  deleteResource(id: string) {
    return this.http.delete(`/resources/${id}`).pipe(
      tap(() => {
        this.resourcesChanged.next();
      })
    );
  }
}
